// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-section {
  background: linear-gradient(145deg, #1e1e1e, #2e2e2e);
  color: white;
  padding: 60px 20px;
  text-align: center;
}

.contact-section-child {
  margin: 100px auto;
  max-width: 1200px;
  padding: 0 20px;
}

.contact-title {
  font-size: 64px;
  text-align: start;
  font-weight: 700;
  margin-bottom: 80px;
  font-family: "Roboto", sans-serif;
}

.contact-container {
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.contact-form {
  background: linear-gradient(145deg, #383838, #181818);
  padding: 40px;
  border-radius: 12px;
  box-shadow: 10px 10px 4px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1 1;
}

.contact-form h2 {
  font-size: 36px;
  margin-bottom: 10px;
  font-weight: 700;
  font-family: "Roboto", sans-serif;
  text-align: start;
}

.contact-form p {
  text-align: start;
}

.contact-form input,
.contact-form textarea {
  padding: 14px;
  border: 1px solid #444;
  background-color: #1e1e1e;
  color: white;
  border-radius: 4px;
  font-size: 16px;
  outline: none;
  resize: none;
}

.contact-form button {
  padding: 12px;
  border: 1px solid white;
  border-radius: 25px;
  background: none;
  color: white;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.contact-form button:hover {
  background: white;
  color: black;
}

.contact-info {
  display: flex;
  flex-direction: column;
  gap: 30px;
  justify-content: center;
  flex: 1 1;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 20px;
  color: white;
}

.info-item h3 {
  margin: 0;
  font-size: 18px;
}

.info-item p {
  margin: 0;
  font-size: 22px;
}

@media (min-width: 768px) {
  .contact-container {
    flex-direction: row;
  }
  .contact-title {
    font-size: 72px;
    margin-left: 0;
  }
  .contact-info {
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }
}
@media (max-width: 768px) {
  .contact-title {
    font-size: 42px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Contact/Contact.scss"],"names":[],"mappings":"AAAA;EACE,qDAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;AACF;;AAEA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iCAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACF;;AAEA;EACE,qDAAA;EACA,aAAA;EACA,mBAAA;EACA,6CAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,SAAA;AACF;;AAEA;EACE,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,iCAAA;EACA,iBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;;EAEE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;AACF;;AAEA;EACE,iBAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;AACF;;AAEA;EAIE;IACE,mBAAA;EAFF;EAKA;IACE,eAAA;IACA,cAAA;EAHF;EAMA;IACE,sBAAA;IACA,uBAAA;IACA,2BAAA;EAJF;AACF;AAQA;EACE;IACE,eAAA;EANF;AACF","sourcesContent":[".contact-section {\n  background: linear-gradient(145deg, #1e1e1e, #2e2e2e);\n  color: white;\n  padding: 60px 20px;\n  text-align: center;\n}\n\n.contact-section-child {\n  margin: 100px auto;\n  max-width: 1200px;\n  padding: 0 20px;\n}\n\n.contact-title {\n  font-size: 64px;\n  text-align: start;\n  font-weight: 700;\n  margin-bottom: 80px;\n  font-family: 'Roboto', sans-serif;\n}\n\n.contact-container {\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n}\n\n.contact-form {\n  background: linear-gradient(145deg, #383838, #181818);\n  padding: 40px;\n  border-radius: 12px;\n  box-shadow: 10px 10px 4px rgba(0, 0, 0, 0.25);\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  flex: 1;\n}\n\n.contact-form h2 {\n  font-size: 36px;\n  margin-bottom: 10px;\n  font-weight: 700;\n  font-family: 'Roboto', sans-serif;\n  text-align: start;\n}\n\n.contact-form p {\n  text-align: start;\n}\n\n.contact-form input,\n.contact-form textarea {\n  padding: 14px;\n  border: 1px solid #444;\n  background-color: #1e1e1e;\n  color: white;\n  border-radius: 4px;\n  font-size: 16px;\n  outline: none;\n  resize: none;\n}\n\n.contact-form button {\n  padding: 12px;\n  border: 1px solid white;\n  border-radius: 25px;\n  background: none;\n  color: white;\n  font-size: 16px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.contact-form button:hover {\n  background: white;\n  color: black;\n}\n\n.contact-info {\n  display: flex;\n  flex-direction: column;\n  gap: 30px;\n  justify-content: center;\n  flex: 1;\n}\n\n.info-item {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  color: white;\n}\n\n.info-item h3 {\n  margin: 0;\n  font-size: 18px;\n}\n\n.info-item p {\n  margin: 0;\n  font-size: 22px;\n}\n\n@media (min-width: 768px) {\n\n\n\n  .contact-container {\n    flex-direction: row;\n  }\n\n  .contact-title {\n    font-size: 72px;\n    margin-left: 0;\n  }\n\n  .contact-info {\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n  }\n}\n\n\n@media (max-width: 768px) {\n  .contact-title {\n    font-size: 42px;\n\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
